import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { OccurencesService } from '../../occurences.service';
import { SessionService } from '../../../core/session/session.service';
import { SnackbarService } from '../../../shared/services/snackbar.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { UtilService } from '../../../shared/utils';
import { HttpResponse } from '@angular/common/http';
import { OccurenceComments } from '@app/occurences/add-occurence-modal/occurence-list-comments/occurence-comments.interface';
import { ValidatedTokenService } from '@app/shared/services/validated-token/validated-token.service';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-occurence-add-comments',
  templateUrl: './occurence-add-comments.component.html',
  styleUrls: ['./occurence-add-comments.component.css']
})
export class OccurenceAddCommentsComponent implements OnInit {

  @Input() commentsOccurrenceForm: FormGroup;
  @Input() occurrenceForm: FormGroup;
  @ViewChild('autosize', { read: false }) autosize: CdkTextareaAutosize;
  @Input() valueLoading: Number;
  @Input() showLoading: Boolean = false;
  @Output() newComment = new EventEmitter();
  filesToUpload: Array<any> = new Array<any>();

  constructor(
    private occurenceService: OccurencesService,
    private sessionService: SessionService,
    private _snackbarService: SnackbarService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    public utils: UtilService,
    private validatedTokenService: ValidatedTokenService,
  ) {
    iconRegistry.addSvgIcon(
      'atachment',
      sanitizer.bypassSecurityTrustResourceUrl('assets/img/atachment.svg'));
  }

  ngOnInit() {
    this.validatedComments();
  }

  onSubmit() {
    this.showLoading = true;
    const payload = {
      occurrenceId: this.occurrenceForm.get('id').value,
      description: this.commentsOccurrenceForm.get('comments').value,
      userName: this.sessionService.getAuthUser().name
    };
    const formData = this.utils.convertPayloadFileToFormData(payload, 'occurrenceComment', this.filesToUpload);
    let msg = '';

    this.occurenceService.addCommentsOccurrence
      (
        formData,
        payload.occurrenceId
      )
      .subscribe(
        event => {

          msg = 'Seu comentário foi enviado com sucesso!';
          this.clearComment();
          this.afterSaveComment(payload.occurrenceId);
          this.showLoading = false;
          this._snackbarService.showSnackbar(msg, 'OK');
        },
        err => {
          msg = `Comentário não enviado!
        Por favor, tente novamente. Caso o problema persista, contate o seu canal de atendimento.`;
          this.showLoading = false;
          this._snackbarService.showSnackbar(msg, 'OK');
        }
      );
  }

  afterSaveComment(occurrenceId: any): void {
    this.newComment.emit(true);
    this.filesToUpload = [];
  }

  validatedComments() {
    const comments = this.commentsOccurrenceForm.get('comments');

    comments.valueChanges
      .pipe(debounceTime(100))
      .subscribe(comment => comments.setValue(this.validatedTokenService.DOMParser(comment)));
  }

  clearComment() {
    this.commentsOccurrenceForm.get('comments').setValue('');
  }

  handleFileInput(event) {
    this.utils.validateFileToUpload(event, this.filesToUpload);
    if (this.filesToUpload.length) {
      this.filesToUpload.forEach(file => {
        file.textSize = this.utils.getSizeFileText(file);
      });
    }
  }

  removeAtachment(index: number) {
    this.filesToUpload.splice(index, 1);
  }

}
